module.exports = __webpack_public_path__ + "static/media/sneakerlist_nobg_blk.01b61974.svg";